module.exports = __webpack_public_path__ + "img/avatar-s-2.da5e73c7.jpg";